import React from 'react';
import './InlineLoader.scss';

interface InlineLoaderProps {
  text?: string;
  size?: 'small' | 'medium' | 'large';
  overlay?: boolean;
}

const InlineLoader: React.FC<InlineLoaderProps> = ({ 
  text = 'Loading...', 
  size = 'medium',
  overlay = true
}) => {
  return (
    <div className={`inline-loader ${size} ${overlay ? 'with-overlay' : ''}`}>
      {overlay && <div className="loader-overlay" />}
      
      <div className="loader-content">
        {/* Simple spinner */}
        <div className="spinner">
          <div className="spinner-circle"></div>
        </div>
        
        {/* Loading text */}
        {text && (
          <div className="loader-text">
            <span>{text}</span>
            <div className="dots">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InlineLoader;